import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="footer">
      <div>
        <strong>R&Do Ltd.</strong>
        <p>Digital innovation, communication, sustainability and European impact.</p>
      </div>

      <div className="footer-links">
        <Link to="/about">About</Link>
        <Link to="/projects">Projects</Link>
        <Link to="/clients-and-synergies">Clients & Synergies</Link>
        <Link to="/news">News</Link>
        <Link to="/contact">Contact</Link>
      </div>
    </footer>
  );
}

export default Footer;